/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_stx_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to use the F1 statistics leaderboards`)
};

const es_f1_stx_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo usar las clasificaciones de estadísticas de F1`)
};

const de_f1_stx_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So nutzt du die F1-Statistik-Ranglisten`)
};

const nl_f1_stx_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe je de F1-statistiekenranglijsten gebruikt`)
};

const fr_f1_stx_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment utiliser les classements de statistiques F1`)
};

const it_f1_stx_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come usare le classifiche statistiche F1`)
};

const pt_br2_f1_stx_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como usar os rankings de estatísticas de F1`)
};

const pt_f1_stx_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como usar as classificações de estatísticas de F1`)
};

const ja_f1_stx_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1統計ランキングの使い方`)
};

const zh_f1_stx_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何使用F1统计排行榜`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_stx_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_stx_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_stx_title", locale)
	if (locale === "en") return en_f1_stx_title(inputs)
	if (locale === "es") return es_f1_stx_title(inputs)
	if (locale === "de") return de_f1_stx_title(inputs)
	if (locale === "nl") return nl_f1_stx_title(inputs)
	if (locale === "fr") return fr_f1_stx_title(inputs)
	if (locale === "it") return it_f1_stx_title(inputs)
	if (locale === "pt-BR") return pt_br2_f1_stx_title(inputs)
	if (locale === "pt") return pt_f1_stx_title(inputs)
	if (locale === "ja") return ja_f1_stx_title(inputs)
	return zh_f1_stx_title(inputs)
};